import React from "react";
import { Button, IconButton } from "@mui/material";
import Download from "./download";

const TableHeader = ({toggleSetting}) => {
  return (
    <div className="main-table-header px-4 py-3">
      <Button
        variant="outlined"
        onClick={() => toggleSetting(true)}
        className="btn-bordered btn-bordered-white d-none d-sm-inline-flex"
        startIcon={<img alt="setting" src="/images/setting.svg" height={16} />}
      >
        Хүснэгтийн тохиргоо
      </Button>
      <IconButton
        variant="outlined"
        onClick={() => toggleSetting(true)}
        className="btn-bordered btn-bordered-white d-flex d-sm-none"
      >
        <img alt="setting" className="mx-0" src="/images/setting.svg" height={16} />
      </IconButton>
      <div className="d-flex">
        <Download />
        <Button
          className="btn-bordered text-secondary d-none d-sm-inline-flex me-2"
          startIcon={<img alt="upload" src="/images/upload.svg" height={14} />}
        >
          Файл оруулах
        </Button>
      </div>
    </div>
  );
};

export default TableHeader;
